


function openPanel() {
    document.getElementById("panel").style.width = "320px"; // Adjusted width
    document.getElementById("panel").style.right = "0"; // Adjusted position
    document.getElementById("overlay").style.width = "100%";
  }

  function closePanel() {
    document.getElementById("panel").style.width = "0";
    document.getElementById("panel").style.right = "-320px"; // Adjusted position
    document.getElementById("overlay").style.width = "0";
  }

// Function to check if the screen size is mobile
function isMobileScreen() {
    return window.innerWidth <= 768; // Adjust the threshold according to your needs
}

// Check if the screen size is mobile
if (isMobileScreen()) {
    // Get all elements with class 'hideonmobile'
    var hideOnMobileElements = document.querySelectorAll('.hideonmobile');

    // Remove all elements with class 'hideonmobile'
    hideOnMobileElements.forEach(function(element) {
        element.parentNode.removeChild(element);
    });
}






window.addEventListener('load', function () {
  // Initialize the slider after all resources including images are loaded
  var carousels = document.querySelectorAll('.main-carousel');
  carousels.forEach(function (carousel) {
    var flickity = new Flickity(carousel, {
      // Flickity options here
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      adaptiveHeight: true,
      resize: true // Enable resizing
    });

    flickity.on('resize', function () {
      // Adjust viewport height based on the tallest image
      var maxHeight = 0;
      flickity.cells.forEach(function (cell) {
        var cellHeight = cell.element.clientHeight;
        maxHeight = Math.max(maxHeight, cellHeight);
      });
      flickity.element.style.height = maxHeight + 'px';
    });

    // Trigger initial resize
    flickity.resize();
  });
});





$(document).ready(function(){
    // Hide all filter groups initially
    $('.filter-group').hide();

    // Toggle filter groups and add/remove active class when accordion header is clicked
    $('.filterfieldset legend').click(function(){
        // Toggle filter groups
        $(this).siblings('.filter-group').slideToggle(100); // 100 milliseconds
        
        // Toggle active class for the closest accordion
        $(this).closest('.accordion2').toggleClass('active2');
        
        // Remove active class from other accordions
        $('.accordion2').not($(this).closest('.accordion2')).removeClass('active2');
    });
});




function isMobile() {
  return window.innerWidth <= 768;
}

$('a[href="#tile1"]').on('click', function(e) {
  e.preventDefault();
  $('legend[for="filter\\.p\\.tag"]').trigger('click');
  if (isMobile()) {
    $('button.filters_mobile.hideondesktop').trigger('click');
  }
});

$('a[href="#tile2"]').on('click', function(e) {
  e.preventDefault();
  $('legend[for="filter\\.p\\.m\\.custom\\.auger_type"]').trigger('click');
  if (isMobile()) {
    $('button.filters_mobile.hideondesktop').trigger('click');
  }
});

$('a[href="#tile3"]').on('click', function(e) {
  e.preventDefault();
  $('legend[for="filter\\.p\\.m\\.custom\\.professional_grade"]').trigger('click');
  if (isMobile()) {
    $('button.filters_mobile.hideondesktop').trigger('click');
  }
});






$(document).ready(function(){
    // Open popup when selection_guide is clicked
    $('.selection_guide').click(function(){
        $('#popupContainer').fadeIn();
    });

    // Close popup when close button is clicked
    $('#closeBtn').click(function(){
        $('#popupContainer').fadeOut();
    });

    // Close popup when clicking outside of the popup content
    $(document).on('click', function(event){
        if ($(event.target).is('#popupContainer')) {
            $('#popupContainer').fadeOut();
        }
    });
});




var _learnq = _learnq || [];

// Function to check if current URL contains "/blogs/"
function logEventBasedOnURL() {
  if (window.location.href.indexOf('/blogs') !== -1) {
    // Get the blog title from the h1 element with class "relative"
    var blogTitleElement = document.querySelector('.itemtitle');
    var blogTitle = blogTitleElement ? blogTitleElement.textContent.trim() : 'Unknown Title';

    // Push the event with the blog title to _learnq
    _learnq.push(["track", "Viewed Blog", { title: blogTitle }]);
    console.log("viewed blog with title:", blogTitle);
  }
}

// Call the function
logEventBasedOnURL();